import keywordTrackerApi from '@/app/KeywordTracker/api/keywordTrackerApi';
import type { DomainSlugArg } from '@/app/KeywordTracker/types/keywordTrackerApiTypes';

const tagsApi = keywordTrackerApi.injectEndpoints({
  endpoints: build => ({
    getTagsForSelect: build.query<unknown, DomainSlugArg>({
      query: domainSlug => ({
        url: `/keyword_tracker/v2/tags/for_select?domainSlug=${domainSlug}`,
        method: 'GET'
      }),
      providesTags: ['tagsForSelect']
    })
  })
});

export const { useGetTagsForSelectQuery } = tagsApi;
export default tagsApi;
